import { Injectable, TemplateRef } from "@angular/core";
import { ReleaseNotesModalServiceType } from "./release-notes-modal.service.type";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../environments/environment";
import { getApp } from "../app";
import {
  updateProfileReleaseVersion,
  getCustomerSettings,
} from "../api.service";
import { ReleaseNote } from "../../../../shared/models/releaseNotes";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ReleaseNotesModalService implements ReleaseNotesModalServiceType {
  private modalRef: any; // To store modal reference
  private modalTemplate!: TemplateRef<any>; // Store template reference
  public releaseNotes: ReleaseNote[] = [];
  public releaseNotesByCustomer: ReleaseNote[] = [];
  public mergedReleaseNotes: ReleaseNote[] = [];

  app = getApp((app) => {
    this.app = app;
  });

  constructor(
    private releaseNotesModalService: NgbModal,
    private http: HttpClient
  ) {}

  setModalTemplate(template: TemplateRef<any>) {
    this.modalTemplate = template;
  }

  async open(showOnlyLastVersion?: boolean) {
    await this.getReleaseNotes();
    await this.getReleaseNotesByCustomer();
    this.mergeReleaseNotes();

    if (showOnlyLastVersion && this.mergedReleaseNotes.length) {
      // only keep the last version
      const lastNote = this.mergedReleaseNotes[0];
      this.mergedReleaseNotes = [lastNote];
    }

    if (this.modalTemplate) {
      this.modalRef = this.releaseNotesModalService.open(this.modalTemplate, {
        windowClass: "mediumModal",
        backdrop: "static",
      });
    }
  }

  mergeReleaseNotes() {
    const merged = this.releaseNotes.map((note: ReleaseNote) => ({
      ...note,
      changes: [...note.changes],
    }));

    this.releaseNotesByCustomer.forEach((customerNote: ReleaseNote) => {
      const generalNote = merged.find(
        (note) => note.version === customerNote.version
      );

      if (generalNote != null) {
        generalNote.changes.push(...customerNote.changes);
      } else {
        // add customer note if it doesn't exist in general
        merged.push({ ...customerNote, changes: [...customerNote.changes] });
      }
    });

    this.mergedReleaseNotes = merged;
  }

  async getReleaseNotes(): Promise<ReleaseNote[]> {
    this.http
      .get<ReleaseNote[]>(
        environment.releaseNotesUrl + "?time=" + new Date().getTime()
      )
      .subscribe((data: any) => {
        this.releaseNotes = data;
      });

    return this.releaseNotes;
  }

  async getReleaseNotesByCustomer(): Promise<ReleaseNote[]> {
    const url = await this.getReleaseNotesUrlByCustomer(
      this.app.customers.expectCurrent
    );

    this.releaseNotesByCustomer = await firstValueFrom(
      this.http.get<ReleaseNote[]>(url + "?time=" + new Date().getTime())
    );

    return this.releaseNotesByCustomer;
  }

  private async getReleaseNotesUrlByCustomer(customer: string) {
    const settings = await getCustomerSettings(customer);
    return settings.releaseNotesModal.url.releaseNotesUrl;
  }

  async close() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
      if (
        this.app.profile.ownProfile.releaseVersions == null ||
        !this.app.profile.ownProfile.releaseVersions.includes(
          environment.version
        )
      ) {
        await updateProfileReleaseVersion(environment.version);
        localStorage.setItem("lastVersionSeen", environment.version);
      }
    }
  }
}
